export const getArcDataEndingAngle = (layer: any) => {
  if (!layer.arcData) {
    console.warn('ArcData: Ending Angle (Sweep) Error');
  }

  return Number(layer.arcData.endingAngle.toFixed(4));
};
